<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="gimBrands"
      :search="search"
      density="compact"
      :items-length="totalItems"
      :loading="loadingDatatables"
      @update:sortBy="toSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiAccountPlus"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-gim-brand") }}
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'gimBrands'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-gim-brand
      :modelDialog="gimBrandDialog"
      @close="gimBrandDialog = false"
    ></add-edit-gim-brand>
  </v-container>
</template>

<script>
import { mdiPencil, mdiDelete, mdiMagnify, mdiAccountPlus } from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import AddEditGimBrand from "./admin/AddEditGimBrand.vue";
import paginate from "@/mixins/paginations";
import { mapState } from "vuex";

export default {
  name: "GimBrandAdmin",
  components: { AddEditGimBrand, PaginationDynamic },
  mixins: [paginate],
  data() {
    return {
      mdiAccountPlus,
      mdiMagnify,
      mdiPencil,
      mdiDelete,
      dialog: false,
      dialogDelete: false,
      gimBrandDialog: false,
      itemsPerPage: 15,
      page: 1,
      headers: [
        { title: "Nom", key: "name" },
        { title: "Actions", key: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapState({
      gimBrands: (state) => state.gimBrands.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
      editedId: (state) => state.gimBrands.editedId
    }),
    pageCount() {
      return Math.ceil(this.gimBrands.length / this.itemsPerPage);
    },
    search: {
      get() {
        return this.$store.state.paginations.search;
      },
      set(value) {
        this.$store.commit("paginations/setSearch", value);
      }
    }
  },
  methods: {
    toSort(item) {
      this.sortBy(item, "gimBrands");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "gimBrands");
    },
    openDialog() {
      this.$store.commit("gimBrands/setEditedId", -1);
      this.$store.commit("gimBrands/setEditedItem", Object.assign({}, {}));
      this.gimBrandDialog = true;
    },
    editItem(item) {
      this.$store.commit("gimBrands/setEditedId", item.id);
      this.$store.commit("gimBrands/setEditedItem", Object.assign({}, item));
      this.gimBrandDialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("alert.delete.gim-brand"))) {
        this.$store
          .dispatch("gimBrands/deleteItem", item.id)
          .then(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.success.gim-brand-delete"),
              color: "success"
            });
            this.toSearchBack(this.search, 500, "gimBrands");
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.gim-brand-delete"),
              color: "error"
            });
          });
      }
    }
  }
};
</script>
